<template>
  <div :class="['agree-provisions', className]" v-if="currentItem">
    <div class="agree-provisions-bg" style="display: none;"></div>
    <div class="agree-provisions-box">
      <slot name="inputCheckBox" v-if="!hasPay"></slot>
      <label :for="labelId">
        {{ !!hasPay ? '您已' : ''}}同意
        <a :href="(currentItem && currentItem.term) ? currentItem.term : '//www.qq.com/contract.shtml'">《服务条款》</a>和
        <a :href="(currentItem && currentItem.privacyPolicy) ? currentItem.privacyPolicy : '//privacy.qq.com'">《隐私政策》</a>
      </label>
      <div class="tip-warn" v-show="!agreeChecked && !hideWarn">
        <i class="icon-warn"></i>
        <span>必须同意以上条款才能购买</span>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * !!!!需要注意 Q币充值指定了groupID,所以currentItem仅有groupid和服务协议、隐私协议字段
 */
export default {
  props: ["currentItem", "labelId", "agreeChecked", "className", "hasPay", "hideWarn"]
}
</script>
